import _defineProperty from "/Users/mac/dev/larcade/ddl-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/mac/dev/larcade/ddl-front/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ColorModeContext } from "./chunk-7NLW6UB6.mjs";
import { getColorModeUtils } from "./chunk-QTTMAIIW.mjs";
import { localStorageManager } from "./chunk-BWTZURQV.mjs";

// src/color-mode-provider.tsx
import { useSafeLayoutEffect } from "@chakra-ui/react-use-safe-layout-effect";
import { useCallback, useEffect, useMemo, useState } from "react";
import { jsx } from "react/jsx-runtime";
var noop = function noop() {};
function getTheme(manager, fallback) {
  return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
function ColorModeProvider(props) {
  var value = props.value,
    children = props.children,
    _props$options = props.options,
    _props$options2 = _props$options === void 0 ? {} : _props$options,
    useSystemColorMode = _props$options2.useSystemColorMode,
    initialColorMode = _props$options2.initialColorMode,
    disableTransitionOnChange = _props$options2.disableTransitionOnChange,
    _props$colorModeManag = props.colorModeManager,
    colorModeManager = _props$colorModeManag === void 0 ? localStorageManager : _props$colorModeManag;
  var defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
  var _useState = useState(function () {
      return getTheme(colorModeManager, defaultColorMode);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    colorMode = _useState2[0],
    rawSetColorMode = _useState2[1];
  var _useState3 = useState(function () {
      return getTheme(colorModeManager);
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    resolvedColorMode = _useState4[0],
    setResolvedColorMode = _useState4[1];
  var _useMemo = useMemo(function () {
      return getColorModeUtils({
        preventTransition: disableTransitionOnChange
      });
    }, [disableTransitionOnChange]),
    getSystemTheme = _useMemo.getSystemTheme,
    setClassName = _useMemo.setClassName,
    setDataset = _useMemo.setDataset,
    addListener = _useMemo.addListener;
  var resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
  var setColorMode = useCallback(function (value2) {
    var resolved = value2 === "system" ? getSystemTheme() : value2;
    rawSetColorMode(resolved);
    setClassName(resolved === "dark");
    setDataset(resolved);
    colorModeManager.set(resolved);
  }, [colorModeManager, getSystemTheme, setClassName, setDataset]);
  useSafeLayoutEffect(function () {
    if (initialColorMode === "system") {
      setResolvedColorMode(getSystemTheme());
    }
  }, []);
  useEffect(function () {
    var managerValue = colorModeManager.get();
    if (managerValue) {
      setColorMode(managerValue);
      return;
    }
    if (initialColorMode === "system") {
      setColorMode("system");
      return;
    }
    setColorMode(defaultColorMode);
  }, [colorModeManager, defaultColorMode, initialColorMode, setColorMode]);
  var toggleColorMode = useCallback(function () {
    setColorMode(resolvedValue === "dark" ? "light" : "dark");
  }, [resolvedValue, setColorMode]);
  useEffect(function () {
    if (!useSystemColorMode) return;
    return addListener(setColorMode);
  }, [useSystemColorMode, addListener, setColorMode]);
  var context = useMemo(function () {
    return {
      colorMode: value != null ? value : resolvedValue,
      toggleColorMode: value ? noop : toggleColorMode,
      setColorMode: value ? noop : setColorMode,
      forced: value !== void 0
    };
  }, [resolvedValue, toggleColorMode, setColorMode, value]);
  return /* @__PURE__ */jsx(ColorModeContext.Provider, {
    value: context,
    children: children
  });
}
ColorModeProvider.displayName = "ColorModeProvider";
function DarkMode(props) {
  var context = useMemo(function () {
    return {
      colorMode: "dark",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    };
  }, []);
  return /* @__PURE__ */jsx(ColorModeContext.Provider, _objectSpread({
    value: context
  }, props));
}
DarkMode.displayName = "DarkMode";
function LightMode(props) {
  var context = useMemo(function () {
    return {
      colorMode: "light",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    };
  }, []);
  return /* @__PURE__ */jsx(ColorModeContext.Provider, _objectSpread({
    value: context
  }, props));
}
LightMode.displayName = "LightMode";
export { ColorModeProvider, DarkMode, LightMode };